import { useLocation, useNavigate } from "react-router-dom-v5-compat";
import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PAST_TRIPS_PATH, TRIPS_PATH } from "@hsbc/utilities";
import { Page, type PageComponentProps } from "@tenant/ui";
import clsx from "clsx";
import { PageHeader } from "../PageHeader";
import styles from "./TripsAppPage.module.scss";

interface TripsAppPageProps extends PageComponentProps {
  contentClassName?: string;
  title?: string;
}

export const TripsAppPage = ({
  children,
  contentClassName,
  title,
  ...props
}: TripsAppPageProps) => {
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.TripsAppPage);

  const { t } = useI18nContext();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Page
      {...props}
      header={
        <PageHeader
          hideSubHeader={[TRIPS_PATH, PAST_TRIPS_PATH].includes(
            location.pathname
          )}
          hideSummary
          title={title ?? t("tripsItineraryTitle")}
          onBackClick={
            props.onBackClick ?? (() => navigate(TRIPS_PATH, { replace: true }))
          }
        />
      }
    >
      <div className={block}>
        <div className={clsx(cn("content"), contentClassName)}>{children}</div>
      </div>
    </Page>
  );
};
